import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'confluent',
});

export const editRouteRef = createSubRouteRef({
  id: 'confluent-edit',
  parent: rootRouteRef,
  path: '/edit/:name',
});
